import { styled, Theme } from '@mui/material';
import { CoreDialogContent } from '@youscience/core';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
    },
  },
  title: {
    margin: '3rem 0 1.5rem 0',
  },
  description: {
    textAlign: 'center',
  },
  additionalText: {
    marginTop: '2rem',
    textAlign: 'center',
  },
  footer: (theme: Theme) => ({
    padding: '1.5rem',
    borderTop: `1px solid ${theme.palette.grey['300']}`,
  }),
};

export const StyledDialogContent = styled(CoreDialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  maxWidth: '600px',
  minHeight: '320px',

  [theme.breakpoints.up('xs')]: {
    minHeight: '384px',
  },
}));
